module.exports = __webpack_public_path__ + "static/media/28-2.8c5547c2.mp3";